import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '@access-request-unicorn/models/app-config.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '@access-request-unicorn/env/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private APP_CONFIG_URL = `${environment.accessRequestBaseUrl}/config`;

  constructor(private http: HttpClient) { }

  getAppConfig(): Observable<AppConfig> {
    return this.http.get<AppConfig>(this.APP_CONFIG_URL);
  }
}
